import { useState, useCallback } from 'react'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { Ticket, Share2, X, Sparkles, Clock, Cake } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useAppStore } from '../store/useAppStore'
import { api } from '../lib/api'

interface HoroscopeData {
  date?: string
  career?: string | null
  finance?: string | null
  love?: string | null
  health?: string | null
  lucky_numbers?: number[]
  lucky_color?: string
  work_color?: string
  love_color?: string
  finance_color?: string
  health_color?: string
  bad_luck_color?: string
  overall_score?: number
  meta?: {
    needs_birth_date?: boolean
    birth_date?: string | null
    started: boolean
    free_used: boolean
    unlocked_today: string[]
    tickets: number
    next_refresh?: string
  }
}

const T = {
  title:        '\u0E14\u0E39\u0E14\u0E27\u0E07\u0E23\u0E32\u0E22\u0E27\u0E31\u0E19',
  loadingMain:  '\u0E01\u0E33\u0E25\u0E31\u0E07\u0E40\u0E1B\u0E34\u0E14\u0E14\u0E27\u0E07\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49...',
  loadingSub:   '\u0E01\u0E23\u0E38\u0E13\u0E32\u0E23\u0E2D\u0E0B\u0E31\u0E01\u0E04\u0E23\u0E39\u0E48',
  startTitle:   '\u0E40\u0E1B\u0E34\u0E14\u0E14\u0E27\u0E07\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49',
  startDesc:    '\u0E14\u0E39\u0E04\u0E30\u0E41\u0E19\u0E19\u0E14\u0E27\u0E07 \u0E40\u0E25\u0E02\u0E21\u0E07\u0E04\u0E25 \u0E2A\u0E35\u0E21\u0E07\u0E04\u0E25 \u0E1F\u0E23\u0E35\u0E17\u0E38\u0E01\u0E27\u0E31\u0E19',
  startBtn:     '\u0E40\u0E23\u0E34\u0E48\u0E21\u0E14\u0E39\u0E14\u0E27\u0E07',
  startNote:    '\u0E14\u0E39\u0E14\u0E27\u0E07\u0E1F\u0E23\u0E35\u0E17\u0E38\u0E01\u0E2B\u0E21\u0E27\u0E14 \u0E17\u0E38\u0E01\u0E27\u0E31\u0E19 \u2728',
  freePrefix:   '\u0E40\u0E1B\u0E34\u0E14\u0E14\u0E27\u0E07\u0E1F\u0E23\u0E35 ',
  scoreTitle:   '\u0E04\u0E30\u0E41\u0E19\u0E19\u0E14\u0E27\u0E07\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49',
  luckyNum:     '\u0E40\u0E25\u0E02\u0E21\u0E07\u0E04\u0E25',
  luckyColor:   '\u0E2A\u0E35\u0E21\u0E07\u0E04\u0E25',
  career:       '\u0E01\u0E32\u0E23\u0E07\u0E32\u0E19',
  finance:      '\u0E01\u0E32\u0E23\u0E40\u0E07\u0E34\u0E19',
  love:         '\u0E04\u0E27\u0E32\u0E21\u0E23\u0E31\u0E01',
  health:       '\u0E2A\u0E38\u0E02\u0E20\u0E32\u0E1E',
  openPrefix:   '\u0E40\u0E1B\u0E34\u0E14\u0E14\u0E39\u0E14\u0E27\u0E07',
  confirmTitle: '\u0E40\u0E1B\u0E34\u0E14\u0E14\u0E27\u0E07',
  useFree:      '\u0E43\u0E0A\u0E49\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E1F\u0E23\u0E35\u0E1B\u0E23\u0E30\u0E08\u0E33\u0E27\u0E31\u0E19 \u0E40\u0E1B\u0E34\u0E14\u0E14\u0E39\u0E14\u0E27\u0E07',
  freeSuffix:   '\u0E44\u0E14\u0E49\u0E40\u0E25\u0E22',
  freeUsedMsg:  '\u0E43\u0E0A\u0E49\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E4C\u0E1F\u0E23\u0E35\u0E44\u0E1B\u0E41\u0E25\u0E49\u0E27\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49',
  useTicket:    '\u0E43\u0E0A\u0E49 1 \u0E15\u0E31\u0E4B\u0E27',
  remaining:    '\u0E40\u0E2B\u0E25\u0E37\u0E2D',
  tickets:      '\u0E43\u0E1A',
  buyPrompt:    '\u0E01\u0E23\u0E38\u0E13\u0E32\u0E0B\u0E37\u0E49\u0E2D\u0E15\u0E31\u0E4B\u0E27\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1B\u0E34\u0E14\u0E14\u0E27\u0E07',
  buyHint:      '\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19 9\u0E3F = 1 \u0E15\u0E31\u0E4B\u0E27',
  cancel:       '\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01',
  buy:          '\u0E0B\u0E37\u0E49\u0E2D\u0E15\u0E31\u0E4B\u0E27',
  opening:      '\u0E01\u0E33\u0E25\u0E31\u0E07\u0E40\u0E1B\u0E34\u0E14...',
  confirm:      '\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19',
  noTickets:    '\u0E44\u0E21\u0E48\u0E21\u0E35\u0E15\u0E31\u0E4B\u0E27\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E1E\u0E2D \u0E01\u0E23\u0E38\u0E13\u0E32\u0E0B\u0E37\u0E49\u0E2D\u0E15\u0E31\u0E4B\u0E27\u0E01\u0E48\u0E2D\u0E19',
  errorGeneral: '\u0E40\u0E01\u0E34\u0E14\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E25\u0E2D\u0E07\u0E43\u0E2B\u0E21\u0E48',
  errorLoad:    '\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E42\u0E2B\u0E25\u0E14\u0E14\u0E27\u0E07\u0E44\u0E14\u0E49 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E25\u0E2D\u0E07\u0E43\u0E2B\u0E21\u0E48',
  retry:        '\u0E25\u0E2D\u0E07\u0E43\u0E2B\u0E21\u0E48',
  shareToday:   '\u0E41\u0E0A\u0E23\u0E4C\u0E14\u0E27\u0E07\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49',
  copied:       '\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E41\u0E25\u0E49\u0E27! \u0E27\u0E32\u0E07\u0E43\u0E19\u0E41\u0E2D\u0E1B\u0E44\u0E14\u0E49\u0E40\u0E25\u0E22',
  disclaimer:   '\u0E04\u0E33\u0E17\u0E33\u0E19\u0E32\u0E22\u0E21\u0E35\u0E44\u0E27\u0E49\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E1A\u0E31\u0E19\u0E40\u0E17\u0E34\u0E07\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19',
  shareDate:    '\u0E14\u0E27\u0E07\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49',
  shareScore:   '\u0E04\u0E30\u0E41\u0E19\u0E19',
  shareApp:     '\u0E14\u0E39\u0E14\u0E27\u0E07\u0E1F\u0E23\u0E35\u0E17\u0E35\u0E48 Amulet Digit',
  alreadyTitle: '\u0E40\u0E1B\u0E34\u0E14\u0E14\u0E27\u0E07\u0E44\u0E1B\u0E41\u0E25\u0E49\u0E27\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49',
  alreadyDesc:  '\u0E14\u0E27\u0E07\u0E08\u0E30\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E27\u0E31\u0E19\u0E43\u0E2B\u0E21\u0E48',
  ok:           '\u0E15\u0E01\u0E25\u0E07',
  refreshAt:    '\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A',
  nextRefresh:  '\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E14\u0E27\u0E07\u0E43\u0E2B\u0E21\u0E48',
  guideNote:    '\u0E14\u0E39\u0E14\u0E27\u0E07 4 \u0E14\u0E49\u0E32\u0E19 + \u0E2A\u0E35\u0E21\u0E07\u0E04\u0E25 6 \u0E2A\u0E35 \u0E1B\u0E23\u0E30\u0E08\u0E33\u0E27\u0E31\u0E19',
}

const COLOR_MAP: Record<string, string> = {
  '\u0E41\u0E14\u0E07':           '#e53e3e',
  '\u0E2A\u0E49\u0E21':           '#ed8936',
  '\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E07': '#d69e2e',
  '\u0E17\u0E2D\u0E07':           '#b8945a',
  '\u0E40\u0E02\u0E35\u0E22\u0E27': '#38a169',
  '\u0E19\u0E49\u0E33\u0E40\u0E07\u0E34\u0E19': '#3182ce',
  '\u0E1F\u0E49\u0E32':           '#63b3ed',
  '\u0E21\u0E48\u0E27\u0E07':     '#805ad5',
  '\u0E0A\u0E21\u0E1E\u0E39':     '#d53f8c',
  '\u0E02\u0E32\u0E27':           '#f7fafc',
  '\u0E14\u0E33':                 '#2d3748',
  '\u0E40\u0E17\u0E32':           '#718096',
  '\u0E19\u0E49\u0E33\u0E15\u0E32\u0E25': '#975a16',
  '\u0E04\u0E23\u0E35\u0E21':     '#fefcbf',
}

function getColorHex(name: string): string {
  for (const [k, v] of Object.entries(COLOR_MAP)) {
    if (name.includes(k)) return v
  }
  return '#b8945a'
}

function formatThaiDate(dateStr: string): string {
  const d = new Date(dateStr + 'T00:00:00')
  const days = ['\u0E2D\u0E32\u0E17\u0E34\u0E15\u0E22\u0E4C','\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C','\u0E2D\u0E31\u0E07\u0E04\u0E32\u0E23','\u0E1E\u0E38\u0E18','\u0E1E\u0E24\u0E2B\u0E31\u0E2A','\u0E28\u0E38\u0E01\u0E23\u0E4C','\u0E40\u0E2A\u0E32\u0E23\u0E4C']
  const months = ['\u0E21.\u0E04.','\u0E01.\u0E1E.','\u0E21\u0E35.\u0E04.','\u0E40\u0E21.\u0E22.','\u0E1E.\u0E04.','\u0E21\u0E34.\u0E22.','\u0E01.\u0E04.','\u0E2A.\u0E04.','\u0E01.\u0E22.','\u0E15.\u0E04.','\u0E1E.\u0E22.','\u0E18.\u0E04.']
  return `\u0E27\u0E31\u0E19${days[d.getDay()]} ${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear() + 543}`
}

function ScoreBar({ score }: { score: number }) {
  const pct = (score / 10) * 100
  const color = score >= 8 ? '#38a169' : score >= 6 ? '#b8945a' : '#e53e3e'
  return (
    <div className="w-full h-2 rounded-full overflow-hidden" style={{ background: 'var(--color-surface-3)' }}>
      <div className="h-full rounded-full transition-all duration-1000"
           style={{ width: `${pct}%`, background: color }} />
    </div>
  )
}

function FullLoadingScreen({ subText }: { subText?: string }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-6 px-8">
      <div className="relative flex items-center justify-center">
        <div className="absolute w-32 h-32 rounded-full animate-ping opacity-20"
             style={{ background: 'var(--gradient-gold)' }} />
        <div className="absolute w-24 h-24 rounded-full animate-ping opacity-30"
             style={{ background: 'var(--gradient-gold)', animationDelay: '0.3s' }} />
        <div className="relative w-20 h-20 rounded-full flex items-center justify-center shadow-2xl"
             style={{ background: 'var(--gradient-gold)', boxShadow: '0 0 40px rgba(184,148,90,0.5)' }}>
          <Sparkles size={36} color="#fff" />
        </div>
      </div>
      <div className="text-center space-y-2">
        <p className="text-base font-semibold" style={{ color: 'var(--color-text)' }}>{T.loadingMain}</p>
        <p className="text-sm" style={{ color: 'var(--color-text-muted)' }}>{subText ?? T.loadingSub}</p>
      </div>
      <div className="flex gap-2">
        {[0, 1, 2].map(i => (
          <div key={i} className="w-2 h-2 rounded-full animate-bounce"
               style={{ background: 'var(--color-gold-dark)', animationDelay: `${i * 0.2}s`, opacity: 0.7 }} />
        ))}
      </div>
    </div>
  )
}

// Birth date form — รับวันเกิด แล้ว save ลง user
const BD = {
  title:    'ใส่วันเกิดของคุณ',
  desc:     'หมอดูจะอ่านดวงให้เฉพาะคุณ จากปีนักษัตรและวันเกิด',
  label:    'วันเกิด',
  save:     'บันทึก',
  saving:   'กำลังบันทึก...',
  invalid:  'วันเกิดไม่ถูกต้อง',
  hint:     'จะจำค่านี้ไว้ — แก้ได้ภายหลังที่หน้าโปรไฟล์',
}

function BirthDateForm({ onSave, loading, error, initial }: {
  onSave: (date: string) => void
  loading: boolean
  error: string | null
  initial?: string | null
}) {
  const today = new Date().toISOString().slice(0, 10)
  const [date, setDate] = useState(initial ?? '')
  const valid = /^\d{4}-\d{2}-\d{2}$/.test(date) && date <= today && date >= '1920-01-01'

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-6 px-8 text-center">
      <div className="relative">
        <div className="absolute inset-0 rounded-full blur-2xl opacity-50"
             style={{ background: 'var(--gradient-gold)' }} />
        <div className="relative w-24 h-24 rounded-full flex items-center justify-center"
             style={{ background: 'var(--gradient-gold)', boxShadow: '0 8px 32px rgba(184,148,90,0.4)' }}>
          <Cake size={44} color="#fff" />
        </div>
      </div>
      <div className="space-y-2">
        <h2 className="text-2xl font-bold" style={{ color: 'var(--color-text)' }}>{BD.title}</h2>
        <p className="text-sm" style={{ color: 'var(--color-text-muted)' }}>{BD.desc}</p>
      </div>
      <div className="w-full max-w-xs flex flex-col gap-3">
        <label className="text-xs font-semibold text-left" style={{ color: 'var(--color-gold-dark)' }}>
          {BD.label}
        </label>
        <input
          type="date"
          value={date}
          max={today}
          min="1920-01-01"
          onChange={e => setDate(e.target.value)}
          className="w-full px-4 py-3 rounded-2xl text-base outline-none"
          style={{
            background: 'var(--color-surface)',
            color: 'var(--color-text)',
            border: '1px solid var(--color-surface-3)',
          }}
        />
        {error && <p className="text-xs text-left" style={{ color: '#e53e3e' }}>{error}</p>}
        <button
          onClick={() => valid && onSave(date)}
          disabled={!valid || loading}
          className="w-full py-4 rounded-2xl font-semibold btn-gold shimmer disabled:opacity-40"
        >
          {loading ? BD.saving : BD.save}
        </button>
      </div>
      <p className="text-xs" style={{ color: 'var(--color-text-soft)' }}>{BD.hint}</p>
    </div>
  )
}

function EmptyState({ onStart, loading }: { onStart: () => void; loading: boolean }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-6 px-8 text-center">
      <div className="relative">
        <div className="absolute inset-0 rounded-full blur-2xl opacity-50"
             style={{ background: 'var(--gradient-gold)' }} />
        <div className="relative w-24 h-24 rounded-full flex items-center justify-center"
             style={{ background: 'var(--gradient-gold)', boxShadow: '0 8px 32px rgba(184,148,90,0.4)' }}>
          <Sparkles size={44} color="#fff" />
        </div>
      </div>
      <div className="space-y-2">
        <h2 className="text-2xl font-bold" style={{ color: 'var(--color-text)' }}>{T.startTitle}</h2>
        <p className="text-sm" style={{ color: 'var(--color-text-muted)' }}>{T.startDesc}</p>
      </div>
      <button
        onClick={onStart}
        disabled={loading}
        className="w-full max-w-xs py-5 rounded-2xl text-lg disabled:opacity-50 select-none btn-gold-3d"
        onPointerDown={e => {
          if (loading) return
          const el = e.currentTarget
          el.style.transform = 'translateY(5px)'
          el.style.boxShadow = '0 1px 0 #7a5820, 0 4px 12px rgba(184,148,90,0.3)'
          el.style.animation = 'none'
        }}
        onPointerUp={e => {
          const el = e.currentTarget
          el.style.transform = ''
          el.style.boxShadow = ''
          el.style.animation = ''
        }}
        onPointerLeave={e => {
          const el = e.currentTarget
          el.style.transform = ''
          el.style.boxShadow = ''
          el.style.animation = ''
        }}
      >
        {loading ? T.loadingMain : '✨ เริ่มดูดวงฟรี ✨'}
      </button>
      <p className="text-xs" style={{ color: 'var(--color-text-soft)' }}>{T.startNote}</p>
    </div>
  )
}

function AlreadyStartedModal({ onClose, nextRefresh }: { onClose: () => void; nextRefresh?: string }) {
  const refreshTime = nextRefresh
    ? new Date(nextRefresh).toLocaleString('th-TH', {
        hour: '2-digit', minute: '2-digit', day: '2-digit', month: 'short',
        timeZone: 'Asia/Bangkok',
      })
    : '00:00'
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-6"
         style={{ background: 'rgba(0,0,0,0.6)' }} onClick={onClose}>
      <div className="w-full max-w-sm rounded-3xl p-6 text-center"
           style={{ background: 'var(--color-surface)' }} onClick={e => e.stopPropagation()}>
        <div className="flex justify-center mb-3">
          <Clock size={32} color="#b8945a" />
        </div>
        <h3 className="text-base font-bold mb-1" style={{ color: 'var(--color-text)' }}>{T.alreadyTitle}</h3>
        <p className="text-sm mb-2" style={{ color: 'var(--color-text-muted)' }}>{T.alreadyDesc}</p>
        <p className="text-xs mb-5" style={{ color: 'var(--color-gold-dark)' }}>
          {T.refreshAt}: {refreshTime}
        </p>
        <button onClick={onClose} className="w-full py-3 rounded-xl font-semibold btn-gold">
          {T.ok}
        </button>
      </div>
    </div>
  )
}

function ShareModal({ data, onClose }: { data: HoroscopeData; onClose: () => void }) {
  const shareText = `${T.shareDate} ${data.date ? formatThaiDate(data.date) : ''}\n${T.shareScore}: ${data.overall_score}/10\n${T.luckyColor}: ${data.lucky_color}\n\n${T.shareApp}\nhttps://www.amuletdigit.com`
  const appUrl = 'https://www.amuletdigit.com'
  const encoded = encodeURIComponent(shareText)

  const channels = [
    { label: 'LINE',     bg: '#06C755', action: () => window.open(`https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(appUrl)}&text=${encoded}`, '_blank') },
    { label: 'IG Post',  bg: '#E1306C', action: () => navigator.clipboard.writeText(shareText).then(() => alert(T.copied)) },
    { label: 'IG Story', bg: '#833AB4', action: () => navigator.clipboard.writeText(shareText).then(() => alert(T.copied)) },
    { label: 'Facebook', bg: '#1877F2', action: () => window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(appUrl)}&quote=${encoded}`, '_blank') },
    { label: 'FB Story', bg: '#1877F2', action: () => navigator.clipboard.writeText(shareText).then(() => alert(T.copied)) },
  ]

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center p-4"
         style={{ background: 'rgba(0,0,0,0.6)' }} onClick={onClose}>
      <div className="w-full max-w-md rounded-3xl pb-6"
           style={{ background: 'var(--color-surface)' }} onClick={e => e.stopPropagation()}>
        <div className="flex justify-center pt-3 pb-1">
          <div className="w-10 h-1 rounded-full" style={{ background: 'var(--color-surface-3)' }} />
        </div>
        <div className="flex items-center justify-between px-5 py-3">
          <div className="flex items-center gap-2">
            <Share2 size={18} style={{ color: 'var(--color-gold-dark)' }} />
            <h3 className="text-sm font-bold" style={{ color: 'var(--color-text)' }}>{T.shareToday}</h3>
          </div>
          <button onClick={onClose} style={{ color: 'var(--color-text-muted)' }}><X size={20} /></button>
        </div>
        <div className="mx-5 mb-4 p-3 rounded-2xl text-xs leading-relaxed whitespace-pre-line"
             style={{ background: 'var(--color-surface-2)', color: 'var(--color-text-muted)' }}>
          {shareText}
        </div>
        <div className="px-5 grid grid-cols-5 gap-2">
          {channels.map(ch => (
            <button key={ch.label} onClick={ch.action}
                    className="flex flex-col items-center gap-1.5 p-2 rounded-2xl transition-transform active:scale-95"
                    style={{ background: 'var(--color-surface-2)' }}>
              <div className="w-10 h-10 rounded-full flex items-center justify-center text-xs font-bold text-white"
                   style={{ background: ch.bg }}>
                {ch.label.slice(0, 2)}
              </div>
              <span className="text-[9px] font-medium text-center leading-tight"
                    style={{ color: 'var(--color-text-muted)' }}>
                {ch.label}
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}

interface CategoryMeta {
  emoji: string
  gradient: string
  accentColor: string
  label: string
}

const CATEGORY_META: Record<string, CategoryMeta> = {
  career: {
    emoji: '⚜️',
    gradient: 'linear-gradient(135deg, #f5e090 0%, #c49030 50%, #8a6020 100%)',
    accentColor: '#c49030',
    label: 'การงาน',
  },
  finance: {
    emoji: '💎',
    gradient: 'linear-gradient(135deg, #a78bfa 0%, #6d28d9 50%, #4c1d95 100%)',
    accentColor: '#7c3aed',
    label: 'การเงิน',
  },
  love: {
    emoji: '🌹',
    gradient: 'linear-gradient(135deg, #fda4af 0%, #e11d48 50%, #9f1239 100%)',
    accentColor: '#e11d48',
    label: 'ความรัก',
  },
  health: {
    emoji: '🌿',
    gradient: 'linear-gradient(135deg, #86efac 0%, #16a34a 50%, #14532d 100%)',
    accentColor: '#16a34a',
    label: 'สุขภาพ',
  },
}

function CategoryCard({ categoryKey, text }: {
  categoryKey: string; text: string | null | undefined;
}) {
  const meta = CATEGORY_META[categoryKey]
  if (!meta) return null

  return (
    <div className="rounded-2xl overflow-hidden card-amulet">
      <div className="px-4 py-3 flex items-center gap-3"
           style={{ borderBottom: '1px solid var(--color-surface-3)' }}>
        <div className="w-9 h-9 rounded-xl flex items-center justify-center text-lg flex-shrink-0"
             style={{ background: meta.gradient, boxShadow: `0 3px 10px ${meta.accentColor}55` }}>
          {meta.emoji}
        </div>
        <span className="text-sm font-bold flex-1" style={{ color: 'var(--color-text)' }}>
          {meta.label}
        </span>
        <div className="w-2 h-2 rounded-full flex-shrink-0"
             style={{ background: meta.accentColor, opacity: 0.7 }} />
      </div>
      <div className="px-4 py-3">
        {text ? (
          <p className="text-sm leading-relaxed" style={{ color: 'var(--color-text)' }}>{text}</p>
        ) : (
          <div className="space-y-2 py-1">
            <div className="h-2.5 rounded" style={{ background: 'var(--color-surface-2)', width: '80%' }} />
            <div className="h-2.5 rounded" style={{ background: 'var(--color-surface-2)', width: '55%' }} />
          </div>
        )}
      </div>
    </div>
  )
}

export default function HoroscopePage() {
  const { lineUid } = useAppStore()
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const [showShare, setShowShare] = useState(false)
  const [startLoading, setStartLoading] = useState(false)
  const [showAlreadyModal, setShowAlreadyModal] = useState<string | undefined>(undefined)
  const [birthSaving, setBirthSaving] = useState(false)
  const [birthError, setBirthError] = useState<string | null>(null)

  const QUERY_KEY = ['horoscope', 'today', lineUid]

  const { data, isLoading, isError, refetch } = useQuery<HoroscopeData>({
    queryKey: QUERY_KEY,
    queryFn: () => api.horoscope.today(lineUid!) as Promise<HoroscopeData>,
    enabled: !!lineUid,
    staleTime: 1000 * 30,
  })

  const handleStart = useCallback(async () => {
    if (!lineUid) return
    setStartLoading(true)
    try {
      const result = await api.horoscope.start(lineUid) as HoroscopeData
      // Set cache directly — no refetch needed (causes flash)
      queryClient.setQueryData(QUERY_KEY, result)
      // Sync tickets in profile (non-blocking)
      queryClient.invalidateQueries({ queryKey: ['user', 'profile', lineUid] })
      queryClient.invalidateQueries({ queryKey: ['user', 'stats', lineUid] })
    } catch (err: unknown) {
      const e = err as Error & { code?: string; nextRefresh?: string }
      if (e.code === 'already_started') {
        setShowAlreadyModal(e.nextRefresh ?? '')
        await refetch()
      } else {
        alert(T.errorGeneral)
      }
    } finally {
      setStartLoading(false)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lineUid, queryClient, refetch])

  const handleSaveBirthDate = useCallback(async (date: string) => {
    if (!lineUid) return
    setBirthSaving(true)
    setBirthError(null)
    try {
      await api.user.setBirthDate(lineUid, date)
      // Force refetch — meta.needs_birth_date should flip to false
      await queryClient.invalidateQueries({ queryKey: QUERY_KEY })
      queryClient.invalidateQueries({ queryKey: ['user', 'profile', lineUid] })
    } catch (err: unknown) {
      const e = err as Error
      setBirthError(e.message || BD.invalid)
    } finally {
      setBirthSaving(false)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lineUid, queryClient])

  const categories = ['career', 'finance', 'love', 'health']

  const meta = data?.meta ?? { started: false, free_used: false, unlocked_today: [], tickets: 0, needs_birth_date: false }
  const started = meta.started
  const needsBirthDate = meta.needs_birth_date === true

  // Initial loading OR Gemini gen loading
  if (isLoading || startLoading) {
    return (
      <div className="flex flex-col min-h-dvh" style={{ background: 'var(--color-bg)' }}>
        <div className="px-4 pt-6 pb-3">
          <h1 className="text-lg font-bold" style={{ color: 'var(--color-text)' }}>{T.title}</h1>
        </div>
        <FullLoadingScreen />
      </div>
    )
  }

  return (
    <div className="flex flex-col min-h-dvh pb-6" style={{ background: 'var(--color-bg)' }}>

      {showShare && data && <ShareModal data={data} onClose={() => setShowShare(false)} />}

      {showAlreadyModal !== undefined && (
        <AlreadyStartedModal onClose={() => setShowAlreadyModal(undefined)} nextRefresh={showAlreadyModal} />
      )}

      <div className="px-4 pt-6 pb-3 flex items-start justify-between">
        <div>
          <div className="flex items-center gap-2 flex-wrap">
            <h1 className="text-lg font-bold" style={{ color: 'var(--color-text)' }}>{T.title}</h1>
            {started && (
              <span className="text-[10px] px-2 py-0.5 rounded-full font-semibold"
                    style={{ background: 'rgba(184,148,90,0.15)', color: 'var(--color-gold-dark)' }}>
                ✨ ฟรีทุกหมวด
              </span>
            )}
          </div>
          {started && data?.meta?.next_refresh && (
            <p className="text-[10px] mt-0.5 flex items-center gap-1" style={{ color: 'var(--color-text-soft)' }}>
              <Clock size={10} />
              {T.nextRefresh}: {new Date(data.meta.next_refresh).toLocaleString('th-TH', { hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Bangkok' })} น.
            </p>
          )}
        </div>
        <button onClick={() => navigate('/store')}
                className="flex items-center gap-1.5 px-3 py-1.5 rounded-xl"
                style={{ background: 'var(--color-surface-2)' }}>
          <Ticket size={14} style={{ color: 'var(--color-gold-dark)' }} />
          <span className="text-xs font-bold" style={{ color: 'var(--color-text)' }}>{meta.tickets}</span>
        </button>
      </div>

      {isError && (
        <div className="mx-4 p-6 rounded-2xl card-amulet text-center">
          <p className="text-sm mb-4" style={{ color: 'var(--color-text-muted)' }}>{T.errorLoad}</p>
          <button onClick={() => refetch()} className="px-6 py-2.5 rounded-xl font-semibold btn-gold">
            {T.retry}
          </button>
        </div>
      )}

      {needsBirthDate && !isError && (
        <BirthDateForm
          onSave={handleSaveBirthDate}
          loading={birthSaving}
          error={birthError}
          initial={meta.birth_date}
        />
      )}

      {!needsBirthDate && !started && !isError && (
        <EmptyState onStart={handleStart} loading={startLoading} />
      )}

      {started && data && (
        <>
          {data?.date && (
            <div className="mx-4 mb-4 text-center">
              <div className="inline-flex flex-col items-center gap-0.5 px-6 py-2.5 rounded-2xl"
                   style={{
                     background: 'var(--color-surface)',
                     border: '1.5px solid var(--color-gold)',
                     boxShadow: '0 2px 12px rgba(184,148,90,0.18)',
                   }}>
                <span className="text-[9px] font-semibold tracking-widest"
                      style={{ color: 'var(--color-text-muted)' }}>
                  ดวงประจำวัน
                </span>
                <span className="text-base font-bold" style={{ color: 'var(--color-gold-dark)' }}>
                  {formatThaiDate(data.date)}
                </span>
              </div>
            </div>
          )}

          <div className="mx-4 mb-4 p-5 rounded-3xl text-center"
               style={{ background: 'var(--gradient-gold)' }}>
            <div className="flex justify-center mb-2">
              <Sparkles size={40} color="#fff" />
            </div>
            <p className="text-white text-xs font-semibold mb-3 opacity-80">{T.scoreTitle}</p>
            <div className="text-5xl font-bold text-white mb-1">
              {data.overall_score}<span className="text-2xl opacity-70">/10</span>
            </div>
            <div className="mx-auto w-48 mt-3">
              <ScoreBar score={data.overall_score ?? 0} />
            </div>
          </div>

          <div className="mx-4 mb-4">
            <p className="text-[10px] font-bold mb-2" style={{ color: 'var(--color-gold-dark)' }}>สีมงคลประจำวัน</p>
            <div className="grid grid-cols-3 gap-2">
              {([
                { label: 'สีมงคล',         value: data.lucky_color,   border: true },
                { label: 'สีเสริมงาน',     value: data.work_color,    border: false },
                { label: 'สีเสริมความรัก', value: data.love_color,    border: false },
                { label: 'สีเสริมการเงิน', value: data.finance_color, border: false },
                { label: 'สีเสริมสุขภาพ',  value: data.health_color,  border: false },
                { label: 'สีกาลกิณี',       value: data.bad_luck_color,border: false },
              ] as { label: string; value?: string; border: boolean }[]).map(({ label, value, border }) => (
                <div key={label} className="p-2.5 rounded-2xl card-amulet flex flex-col items-center gap-1.5"
                     style={border ? { border: '1.5px solid var(--color-gold)' } : {}}>
                  <div className="w-9 h-9 rounded-full border-2 flex-shrink-0"
                       style={{
                         background: getColorHex(value ?? ''),
                         borderColor: label === 'สีกาลกิณี' ? '#e53e3e55' : 'var(--color-surface-3)',
                         boxShadow: `0 2px 8px ${getColorHex(value ?? '')}55`,
                       }} />
                  <span className="text-[9px] font-semibold text-center leading-tight"
                        style={{ color: label === 'สีกาลกิณี' ? 'var(--color-danger)' : 'var(--color-text-muted)' }}>
                    {label}
                  </span>
                  <span className="text-[10px] font-bold" style={{ color: label === 'สีกาลกิณี' ? 'var(--color-danger)' : 'var(--color-text)' }}>
                    {value ?? '—'}
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className="mx-4 mb-1 text-center">
            <p className="text-[10px] flex items-center justify-center gap-1" style={{ color: 'var(--color-text-soft)' }}>
              <Sparkles size={10} />
              {T.guideNote}
            </p>
          </div>

          <div className="mx-4 flex flex-col gap-3">
            {categories.map(key => (
              <CategoryCard
                key={key}
                categoryKey={key}
                text={(data as unknown as Record<string, string | null | undefined>)[key]}
              />
            ))}
          </div>

          <button onClick={() => setShowShare(true)}
                  className="mx-4 mt-5 py-3.5 rounded-2xl font-semibold flex items-center justify-center gap-2"
                  style={{ background: 'var(--color-surface-2)', color: 'var(--color-text-muted)' }}>
            <Share2 size={16} />
            {T.shareToday}
          </button>

          <p className="text-center text-[10px] mt-4 px-6" style={{ color: 'var(--color-text-soft)' }}>
            {T.disclaimer}
          </p>
        </>
      )}
    </div>
  )
}
